import { useEffect, useState, useRef } from "react";
import VoxeetSDK from "@voxeet/voxeet-web-sdk";
import { useRoomStore } from "../../stores/room";
import { useUserStore } from "../../stores/user";
import { useParams } from "react-router";
import { DirectRoom } from "./direct";
import { Modal, Select, Form, Button } from 'antd';

import styles from './rooms.module.css';
import { upload } from "../../libs/utils";
import { GroupRoom } from "./group";
import { PresentationRoom } from "./presentation";
import { AuditoriumRoom } from "./auditorium";
import { ConferenceRoom } from "./conference";
import { WorkspaceRoom } from "./workspace";
import { TestRoom } from "./test";
import { Share } from "../../widgets/share";

export function Room() {
  const { id } = useParams();
  const { open, type, sendMessage, leave, join, name } = useRoomStore();
  const { id: userId } = useUserStore();
  const [isLoading, setIsLoading] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [videoDevices, setVideoDevices] = useState([]);
  const [audioDevices, setAudioDevices] = useState([]);
  const [showUnblocker, setShowUnblocker] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [selectedVideoDevice, setSelectedVideoDevice] = useState(localStorage.getItem('videoDevice'));
  const [selectedAudioDevice, setSelectedAudioDevice] = useState(localStorage.getItem('audioDevice'));
  useEffect(() => {
      setIsLoading(true);
      open(id).then(room => {
        document.body.querySelector('.App').classList.add('solid');
        setIsLoading(false);
      });
      return () => {
        console.log("UPLOADING");
        leave();
        useRoomStore.destroy();
      }
  }, [id]);

  useEffect(() => {
    VoxeetSDK.mediaDevice.enumerateVideoDevices()
    .then(devices => {
      setVideoDevices(devices);
      return VoxeetSDK.mediaDevice.enumerateAudioDevices();
    })
    .then(devices => {
      setAudioDevices(devices);
    });
    VoxeetSDK.conference.on("autoplayBlocked", () => {
      setShowUnblocker(true);
    });
  }, []);

  return (!isLoading ?
    <div className={styles.room}  onDragOver={e => {
      // e.preventDefault();
      // e.stopPropagation();
      // console.log('DRAG FILE0', e);
  }} onDrop={e => {
      // e.preventDefault();
      // e.stopPropagation();
      // console.log('DROP', e.dataTransfer.files, e.dataTransfer.items)
      // upload(e.dataTransfer.files[0], `rooms/${id}`)
  }}>
      {type === 'personal' && <DirectRoom  onReady={(options) => {
        return join(options);
      }} onOpenSettings={() => {
        setShowSettings(true);
      }} onOpenShare={() => {
        setShowShare(true);
      }} />}

      {type === 'group' && <GroupRoom  onReady={(options) => {
        return join(options);
      }} onOpenSettings={() => {
        setShowSettings(true);
      }} onOpenShare={() => {
        setShowShare(true);
      }} />}

      {type === 'presentation' && <PresentationRoom  onReady={(options) => {
        return join(options);
      }} onOpenSettings={() => {
        setShowSettings(true);
      }} onOpenShare={() => {
        setShowShare(true);
      }} />}

      {type === 'auditorium' && <AuditoriumRoom  onReady={(options) => {
        return join(options);
      }} onOpenSettings={() => {
        setShowSettings(true);
      }} onOpenShare={() => {
        setShowShare(true);
      }} />}

      {type === 'conference' && <ConferenceRoom onReady={(options) => {
        return join(options);
      }} onOpenSettings={() => {
        setShowSettings(true);
      }} onOpenShare={() => {
        setShowShare(true);
      }}  />}

      {type === 'workspace' && <WorkspaceRoom onReady={(options) => {
        return join(options);
      }} onOpenSettings={() => {
        setShowSettings(true);
      }} onOpenShare={() => {
        setShowShare(true);
      }}  />}

      {type === 'watercooler' && <div className="underdevelopment">Under Development</div>}
      
      <div className={styles.uploadoverlay}>
        Drop Your Files
      </div>
      <Modal title="Device Settings" visible={showSettings} style={{ color: 'white' }} footer={<div style={{ width: '100%', display: 'flex' }}>
        <span style={{ flex: 1 }} />
        <Button type="ghost" onClick={() => {
          setSelectedVideoDevice(localStorage.getItem('videoDevice'));
          setSelectedAudioDevice(localStorage.getItem('audioDevice'));
          setShowSettings(false);
          VoxeetSDK.conference.playBlockedAudio();
        }}>Cancel</Button>
        <Button type="primary" onClick={() => {
          VoxeetSDK.mediaDevice.selectVideoInput(selectedVideoDevice);
          VoxeetSDK.mediaDevice.selectAudioInput(selectedAudioDevice);
          localStorage.setItem('videoDevice', selectedVideoDevice);
          localStorage.setItem('audioDevice', selectedAudioDevice);
          setShowSettings(false);
          VoxeetSDK.conference.playBlockedAudio();
        }}>Save</Button>
      </div>}
      getContainer={() => document.body}
      onCancel={() => {
        setSelectedVideoDevice(localStorage.getItem('videoDevice'));
        setSelectedAudioDevice(localStorage.getItem('audioDevice'));
        setShowSettings(false);
        VoxeetSDK.conference.playBlockedAudio();
      }}>
        <Form layout="vertical">
          <Form.Item label="Video Device">
            <Select value={selectedVideoDevice} onChange={deviceId => {
              setSelectedVideoDevice(deviceId);
            }}>
              {videoDevices.map(device => (
                <Select.Option key={device.deviceId} value={device.deviceId}>
                  {device.label}
                </Select.Option>
              ))}
            </Select>        
          </Form.Item>
          <Form.Item label="Audio Device">
            <Select value={selectedAudioDevice} onChange={deviceId => {
              setSelectedAudioDevice(deviceId);
            }}>
              {audioDevices.map(device => (
                <Select.Option key={device.deviceId} value={device.deviceId}>
                  {device.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      {showUnblocker && <div className={styles.unblocker}>
        <h1>You are entering room "{name}"</h1>
        <Button type="primary" onClick={() => {
          VoxeetSDK.conference.playBlockedAudio();
          setShowUnblocker(false);
        }}>Proceed</Button>
      </div>}
      {showShare && <Share onCancel={() => {
        setShowShare(false);
      }} />}
    </div> : 'Loading...'
  );
}
